import { CircularProgress, Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getProducts } from '../../../actions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { customStyles, justifyCenter } from '../../../styles'
import { MainContainer } from '../../containers'
import { SubTitle } from '../../helpers'
import SaveAsIcon from '@mui/icons-material/SaveAs';
export const SavingAddressScreen = () => {
  const { account } = useSelector(state => state.order)
  const { code, message } = useSelector(state => state.status)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [authorization] = useLocalStorage('login-token', null)

  useEffect(() => {
    if(account) {
      dispatch(getProducts(account?.id, authorization?.token))
      const timer = setTimeout(() => {
        const lower = account.type.toLowerCase()
        navigate(`/dashboard/${account?.id}/${lower}`, {replace: true})
      }, 5000);
  
      return () => {
        clearTimeout(timer)
      }
    }
  }, [account])

  useEffect(() => {
    let timer
    if(code){
      timer = setTimeout(() => {
          navigate(-1)
      }, 5000);      
    }

    return () => {
      clearTimeout(timer)
    }
  }, [])
  return (
    <MainContainer >
      <Stack height="80vh" spacing={3} alignItems="center" justifyContent="center">
        <SaveAsIcon sx={{fontSize: 50, color: customStyles.colors.main}}/>
        <SubTitle text="Guardando Cuenta" color={customStyles.colors.main}/>
        {
          code 
            ? <SubTitle text={message}/>
            : <CircularProgress />
        }
      </Stack>
    </MainContainer>
  )
}
